exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "table[data-v-a2132964]{border-collapse:collapse}table[data-v-a2132964],td[data-v-a2132964],th[data-v-a2132964]{border:1px solid #000}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/components/pos/receipt_list.vue"],"names":[],"mappings":"AACA,uBACE,wBAA0B,CAC3B,AACD,+DAGE,qBAAwB,CACzB","file":"receipt_list.vue","sourcesContent":["\ntable[data-v-a2132964] {\n  border-collapse: collapse;\n}\ntable[data-v-a2132964],\nth[data-v-a2132964],\ntd[data-v-a2132964] {\n  border: 1px solid black;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a2132964","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pos/receipt_list.vue
// module id = 1230
// module chunks = 0